import { render, staticRenderFns } from "./DomainBackToTop.vue?vue&type=template&id=6ed8aa8a&scoped=true&"
import script from "./DomainBackToTop.vue?vue&type=script&lang=js&"
export * from "./DomainBackToTop.vue?vue&type=script&lang=js&"
import style0 from "./DomainBackToTop.vue?vue&type=style&index=0&id=6ed8aa8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed8aa8a",
  null
  
)

export default component.exports